import { Reveal, ChapterTag } from "@/components/Reveal";

const STEPS = [
  {
    n: "1",
    title: "Load.",
    copy: "A clear top hopper designed to hold in-shell peanuts.",
    testId: "step-load",
  },
  {
    n: "2",
    title: "Turn.",
    copy: "A hand-crank approach to the shelling process.",
    testId: "step-turn",
  },
  {
    n: "3",
    title: "Collect.",
    copy: "Separate drawers intended to gather peanuts and shells.",
    testId: "step-collect",
  },
];

export const Design = () => (
  <section id="design" data-testid="product-design-section" className="scroll-mt-24 bg-[#EADCC6] py-20 sm:py-28 lg:py-32">
    <div className="mx-auto grid max-w-7xl items-center gap-12 px-4 sm:px-6 lg:grid-cols-2 lg:gap-16 lg:px-8">
      <Reveal y={40} className="lg:order-1">
        <div className="overflow-hidden rounded-[2rem] shadow-[0_40px_80px_-40px_rgba(7,67,69,0.45)]">
          <img
            data-testid="design-image"
            src="/assets/peanut-valet-hand-crank-design.webp"
            srcSet="/assets/peanut-valet-hand-crank-design-900.webp 900w, /assets/peanut-valet-hand-crank-design.webp 1448w"
            sizes="(max-width: 1024px) 100vw, 50vw"
            alt="Peanut Valet design showing the complete hopper lid, right-side hand crank and two collection drawers."
            width="1448"
            height="1086"
            loading="lazy"
            className="h-auto w-full"
          />
        </div>
      </Reveal>

      <div className="lg:order-2">
        <Reveal>
          <ChapterTag number="02" label="The Design" />
        </Reveal>
        <Reveal delay={0.08}>
          <h2 className="mt-6 text-[1.9rem] font-extrabold leading-tight tracking-tight text-[#074345] sm:text-4xl lg:text-[2.6rem]">
            A little turn. A lot of thought.
          </h2>
        </Reveal>
        <Reveal delay={0.14}>
          <p className="mt-5 max-w-lg text-base leading-relaxed text-[#243C39] sm:text-lg">
            A hand-crank design, a clear view of the contents, and separate collection
            drawers&mdash;all brought together in Peanut Valet&rsquo;s signature colors.
          </p>
        </Reveal>

        <div className="mt-10 space-y-2">
          {STEPS.map((step, i) => (
            <Reveal key={step.n} delay={0.1 + i * 0.08}>
              <div
                data-testid={step.testId}
                className="group flex items-start gap-5 rounded-2xl p-4 transition-colors duration-300 hover:bg-[#F7F1E6]"
              >
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-[#F3802A] text-lg font-black text-[#043436] transition-transform duration-300 group-hover:scale-110">
                  {step.n}
                </span>
                <div>
                  <h3 className="text-xl font-extrabold text-[#074345]">{step.title}</h3>
                  <p className="mt-1 text-base leading-relaxed text-[#506460]">{step.copy}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
